import React, {Component} from 'react';
import FusionCharts from 'fusioncharts/core';
import Scatter from 'fusioncharts/viz/scatter';
import Column2D from 'fusioncharts/viz/column2d';
import Radar from 'fusioncharts/viz/radar';
import ReactFC from 'react-fusioncharts';
import { chartConfigGenerator, shipmentDelayDistribution, avgShipmentDelay, avgDelayForCustomers, CustomerTabLoader, DelayTabLoader} from '../util/index';


ReactFC.fcRoot(FusionCharts, Scatter, Column2D, Radar);
export default class ChartContainerSecond extends Component {
    render () {
      let {data, timeSelectorValue, theme} = this.props;
      return (
        <div className="row m-auto chart-container">
            <div className="col-12 chart-wrapper" id="chart-wrapper2">
              <div className="chart-header kpi-header">Shipment Delay Distribution</div>
              <div className="second-chart" id="chart-container2">{(data.length)? <ReactFC {...chartConfigGenerator({type: 'scatter', theme: theme, dataSource: shipmentDelayDistribution, data: data, timeSelectorValue: timeSelectorValue })}/> : <CustomerTabLoader />}</div>
            </div>
            <div className="col-12 col-lg-6 chart-wrapper" id="chart-wrapper3">
              <div className="chart-header kpi-header">Average Shipment Delay Across Regions</div>
              <div className="second-chart" id="chart-container3">{(data.length)? <ReactFC {...chartConfigGenerator({type: 'column2d', theme: theme, dataSource: avgShipmentDelay, data: data, timeSelectorValue: timeSelectorValue })} /> : <DelayTabLoader />}</div>
            </div>
            <div className="col-12 col-lg-6 chart-wrapper" id="chart-wrapper4">
              <div className="chart-header kpi-header">Average Delay For Important Customers</div>
              <div className="second-chart" id="chart-container4">{(data.length)? <ReactFC {...chartConfigGenerator({type: 'radar', theme: theme, dataSource: avgDelayForCustomers, data: data, timeSelectorValue: timeSelectorValue })} /> : <DelayTabLoader />}</div>
            </div>
        </div>
      );
    }
}


// WEBPACK FOOTER //
// ./src/components/DelayOverviewTab.js